import { borderRadius, zIndexes } from "@iventis/styles/src/atomic-rules";
import React, { FunctionComponent } from "react";
import { media, styled } from "@iventis/styles";

interface ToolBarPosition {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
    translateX?: string;
}

export const DrawToolBarComponent: FunctionComponent<{ position: ToolBarPosition; boxShadowColour: string; children?: React.ReactNode; className?: string; testId?: string }> = ({
    children,
    position,
    boxShadowColour,
    className,
    testId,
}) => (
    <StyledDrawToolBarContainer position={position} boxShadowColour={boxShadowColour} className={className} data-testid={testId}>
        {children}
    </StyledDrawToolBarContainer>
);
const StyledDrawToolBarContainer = styled.div<{ position: ToolBarPosition; boxShadowColour: string }>`
    // min 20px padding on each side
    max-width: calc(100% - 40px);
    width: max-content;
    position: absolute;
    top: ${(props) => (props.position.top != null ? props.position.top : null)};
    right: ${(props) => (props.position.right != null ? props.position.right : null)};
    bottom: ${(props) => (props.position.bottom != null ? props.position.bottom : null)};
    left: ${(props) => (props.position.left != null ? props.position.left : null)};
    transform: ${(props) => (props.position.translateX != null ? `translateX(${props.position.translateX})` : null)};
    background-color: white;
    border-radius: ${borderRadius.standard};
    box-shadow: 0px 4px 20px 0px rgba(81, 82, 101, 0.2592);
    padding: 4px;
    display: none;
    flex-direction: row;
    ${media.medium} {
        display: flex;
        flex-wrap: wrap;
    }
    // needs to be above the sidebar
    z-index: ${zIndexes.drawingToolbar};
`;
